

<nb-layout>
  <nb-layout-header fixed>
    <div class="flex-container" style="width: 100%; display: flex;">
      <div class="text-left" style="flex-grow: 1">
        <button nbButton size="large" (click)="toggle()" status="primary"> filters <nb-icon icon="menu-outline" ></nb-icon> </button>
      </div>

      <div class="text-left" style="flex-grow: 3">
        <a href="https://dasec.ma">
          <img src="../../assets/logoo.svg" width="150rem">
        </a>
      </div>

      <div style="flex-grow: 7"></div>

      <div class="text-right" style="flex-grow: 30">
        <button nbButton size="large" (click)="openInfo()" status="info"> Info<nb-icon icon="alert-circle-outline" ></nb-icon> </button>

      </div>
    </div>


  </nb-layout-header>

  <nb-sidebar tag="left"
              responsive="true"
              [collapsedBreakpoints]="['xs', 'is', 'sm', 'md', 'lg']">

    <nb-accordion>

      <nb-accordion-item>
        <nb-accordion-item-header>Headquarters</nb-accordion-item-header>
        <nb-accordion-item-body>
          <nb-list *ngIf="!isLoading">
            <nb-list-item  *ngFor="let c of render['countries']" >
              <nb-checkbox [value]="c"
                           [checked]="render['filter_hq'].includes(c)"
                           (checkedChange)="checked($event, c, 'filter_hq')">{{c}}</nb-checkbox>
            </nb-list-item>
          </nb-list>
        </nb-accordion-item-body>
      </nb-accordion-item>


      <nb-accordion-item>
        <nb-accordion-item-header>Size</nb-accordion-item-header>
        <nb-accordion-item-body>
          <nb-list *ngIf="!isLoading">
            <nb-list-item  *ngFor="let c of render['human_res']" >
              <nb-checkbox [value]="c"
                           [checked]="render['filter_hr'].includes(c)"
                           (checkedChange)="checked($event, c, 'filter_hr')">{{c}}</nb-checkbox>
            </nb-list-item>
          </nb-list>
        </nb-accordion-item-body>
      </nb-accordion-item>

      <nb-accordion-item>
        <nb-accordion-item-header>Services</nb-accordion-item-header>
        <nb-accordion-item-body>
          <nb-list *ngIf="!isLoading">
            <nb-list-item  *ngFor="let c of render['tags']" >
              <nb-checkbox [value]="c"
                           [checked]="render['filter_tags'].includes(c)"
                           (checkedChange)="checked($event, c, 'filter_tags')">{{capitaliz(c)}}</nb-checkbox>
            </nb-list-item>
          </nb-list>
        </nb-accordion-item-body>
      </nb-accordion-item>
    </nb-accordion>

  </nb-sidebar>

  <nb-layout-column>


    <div class="row">

      <div class="col-lg-6 col-sm-12">
        <nb-card>
          <nb-card-header>Headquarters</nb-card-header>
          <nb-card-body>

            <ngx-chartjs-pie *ngIf="!isLoading"
                             [data]=" {'datasets': [{'data': render['nbr_hq'].data[0] }], 'labels': render['nbr_hq'].labels}" ></ngx-chartjs-pie>

          </nb-card-body>
        </nb-card>
      </div>

      <div class="col-lg-6 col-sm-12">
        <nb-card>
          <nb-card-header>Number of Employees</nb-card-header>
          <nb-card-body>

            <ngx-chartjs-pie *ngIf="!isLoading"
                             [data]=" {'datasets': [{'data': render['hr_hq'].data[0] }], 'labels': render['hr_hq'].labels}" ></ngx-chartjs-pie>

          </nb-card-body>
        </nb-card>
      </div>

    </div>

    <div class="row">

      <div class="col-lg-6 col-sm-12">
        <nb-card>
          <nb-card-header>Capital</nb-card-header>
          <nb-card-body>

            <ngx-chartjs-pie *ngIf="!isLoading"
                             [data]=" {'datasets': [{'data': render['cap_hq'].data[0] }], 'labels': render['cap_hq'].labels}" ></ngx-chartjs-pie>

          </nb-card-body>
        </nb-card>
      </div>


      <div class="col-lg-6 col-sm-12">
        <nb-card>
          <nb-card-header>Foundation date</nb-card-header>
          <nb-card-body>


            <ngx-chartjs-line *ngIf="render['date']!=='await'"
                              [options]="{x:'year of foundation', y:'# of companies'}"
                              [data]=" {'datasets': render['nbr_year'].data, 'labels': render['nbr_year'].labels}" ></ngx-chartjs-line>

          </nb-card-body>
        </nb-card>
      </div>


    </div>


  </nb-layout-column>



</nb-layout>
